import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { selectUserInfos } from '../../store/userDataStore';
import MyAttendanceTab from './MyAttendanceTab';
import OverviewTab from './OverviewTab';
import RollCallTab from './RollCallTab';
import SessionsAdminTab from './SessionsAdminTab';

// Menu Assiduité — onglets selon le rôle :
// étudiant·e : ses séances et présences ; enseignant·e : vue promo + saisie de ses séances ;
// admin : idem sur toutes les séances + paramétrage des séances (import du fichier de service).
// Les dates des cycles sont dans Admin Cycles.
const AttendancePage: React.FC = () => {
  const userInfos = useSelector(selectUserInfos);
  const isAdmin = userInfos?.access === 'admin';
  const isTeacher = userInfos?.access === 'teacher' || isAdmin;

  const tabs = isTeacher
    ? [
        { key: 'overview', label: 'Vue promo' },
        { key: 'roll', label: "Saisie de l'appel" },
        ...(isAdmin ? [{ key: 'sessions', label: 'Séances' }] : []),
      ]
    : [{ key: 'mine', label: 'Mon assiduité' }];
  const [tab, setTab] = useState(tabs[0].key);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Assiduité</Typography>
      {tabs.length > 1 && (
        <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 3 }}>
          {tabs.map(t => <Tab key={t.key} value={t.key} label={t.label} />)}
        </Tabs>
      )}
      {tab === 'mine' && <MyAttendanceTab />}
      {tab === 'overview' && <OverviewTab />}
      {tab === 'roll' && <RollCallTab isAdmin={isAdmin} />}
      {tab === 'sessions' && isAdmin && <SessionsAdminTab />}
    </Box>
  );
};

export default AttendancePage;
